import type { AgencyCategory } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { ScrollArea } from '@/components/ui/scroll-area'
import { TabsContent } from '@/components/ui/tabs'

import type { AgencyFormSchemaType } from './agency-form.schema'
import { AgencyFormPresentationTab } from './agency-form-presentation-tab.molecule'
import { AgencyFormSystemTab } from './agency-form-system-tab.molecule'
import { AgencyFormTemplatesTab } from './agency-form-templates-tab.molecule'

interface AgencyFormTabsContentProps {
  form: UseFormReturn<AgencyFormSchemaType>
  categoryList: AgencyCategory[]
  logoPreviewUrl: string | null
  onLogoChange: (file: File | null) => void
  onLogoRemove: () => void
  isDisabled: boolean
  agencySlug?: string
}

/**
 * Scrollable content area for the agency form tabs.
 */
export const AgencyFormTabsContent = ({
  form,
  categoryList,
  logoPreviewUrl,
  onLogoChange,
  onLogoRemove,
  isDisabled,
  agencySlug,
}: AgencyFormTabsContentProps): ReactNode => (
  <ScrollArea className="agency-form-scroll min-h-0 flex-1 [&>[data-slot=scroll-area-viewport]]:h-full">
    <TabsContent value="presentation" className="agency-form-presentation mt-0 px-4 pb-4">
      <AgencyFormPresentationTab
        form={form}
        categoryList={categoryList}
        logoPreviewUrl={logoPreviewUrl}
        onLogoChange={onLogoChange}
        onLogoRemove={onLogoRemove}
        isDisabled={isDisabled}
      />
    </TabsContent>

    <TabsContent value="system" className="agency-form-system mt-0 px-4 pb-4">
      <AgencyFormSystemTab form={form} isDisabled={isDisabled} />
    </TabsContent>

    <TabsContent value="templates" className="agency-form-templates mt-0 px-4 pb-4">
      <AgencyFormTemplatesTab agencySlug={agencySlug} isDisabled={isDisabled} />
    </TabsContent>
  </ScrollArea>
)

AgencyFormTabsContent.displayName = 'AgencyFormTabsContent'
